import { Box, Divider, useTheme } from '@mui/material'
import CustomButton from 'components/Fileds/CustomButton';
import CustomSearch from 'components/Fileds/CustomSearch';
import CustomTypography from 'components/Fileds/CustomTypography'
import React from 'react'
import { useNavigate } from 'react-router-dom';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import AddIcon from '@mui/icons-material/Add';
import CustomSelect from 'components/Fileds/CustomSelect';

const HeaderTilteBar = ({ title, isSearch, addDisabled = false, onSearchChange, searchQuery, btnText, handleAddBtn, isAddVisible = true,
    isSecondBtn = false, handleCategoryBtn, secondBtnText, padding, children, isFilter = false, categories,
    selectedCategory, onCategoryChange, rightContent, beforeSearchContent, isIcon = true, onBack, searchPlaceholder,
    searchWidth, searchSx
}) => {
    const theme = useTheme();
    const navigate = useNavigate();
    const handleBack = () => {
        if (onBack) {
            onBack();
        } else {
            navigate(-1);
        }
    }
    return (
        <Box sx={{ padding: padding ? padding : '0px', paddingTop: '10px', }}>
            <Box className='d-flex align-items-center justify-content-between' sx={{ flexWrap: 'wrap', rowGap: 1.5, columnGap: 1 }}>
                {/* Back Arrow Icon & Screen Title */}
                <Box className='d-flex align-items-center' sx={{ gap: { xs: 1, sm: 1.5 }, flexWrap: 'wrap' }}>
                    <Box className='back-rounded-icon d-flex align-items-center justify-content-center cursor-pointer'
                        onClick={handleBack}
                        sx={{ border: '1px solid #4D4D4D', borderRadius: '50%', width: '30px', height: '30px', marginTop: '2px', flexShrink: 0 }}>
                        <ChevronLeftIcon />
                    </Box>
                    <CustomTypography
                        label={title}
                        variant={"h5"}
                        sx={{
                            fontSize: '24px', fontWeight: 600,
                            color: theme.palette.typographyLabel.main, mb: 0,
                            whiteSpace: 'nowrap'
                        }}
                    />
                    {children}
                </Box>

                {/* Search & Add Button */}
                <Box className='d-flex align-items-center' sx={{ gap: { xs: 1, sm: 1.2 }, flexWrap: 'wrap' }}>
                    {isFilter &&
                        <Box className='d-flex align-items-center' sx={{ gap: 2 }}>
                            <CustomSelect
                                name="category"
                                // placeholder="All Categories"
                                options={[
                                    { value: '', label: 'All Categories' },
                                    ...(categories ?? []).map((cat) => ({
                                        value: cat.id,
                                        label: cat.name,
                                    }))
                                ]}
                                value={selectedCategory ?? ''}
                                onChange={(e) => onCategoryChange?.(e.target.value)}
                                sx={{ borderRadius: '10px', backgroundColor: '#fff', fontSize: '14px', minWidth: 160 }}
                            />
                        </Box>
                    }

                    {beforeSearchContent && beforeSearchContent}

                    {isSearch &&
                        <Box sx={{ width: searchWidth || { xs: '100%', sm: 175, md: 195, lg: 215 }, minWidth: { sm: 140 }, ...searchSx }}>
                            <CustomSearch
                                onSearchChange={onSearchChange}
                                searchQuery={searchQuery}
                                placeholder={searchPlaceholder || "Search with Name"}
                                isLoading={false}
                            />
                        </Box>
                    }

                    {rightContent && rightContent}

                    {isSecondBtn &&
                        <CustomButton
                            fullWidth
                            sx={{
                                borderRadius: "10px", width: "160px", backgroundColor: 'transparent', color:
                                    theme.palette.primary.main, border: `1px solid ${theme.palette.primary.main}`
                            }}
                            onClick={handleCategoryBtn}
                        // disabled={addDisabled}
                        >
                            {secondBtnText}
                        </CustomButton>
                    }

                    {isAddVisible &&
                        <CustomButton
                            // fullWidth
                            sx={{ borderRadius: "10px", width: "160px", minWidth: "160px" }}
                            onClick={handleAddBtn}
                            startIcon={isIcon && <AddIcon />}
                            disabled={addDisabled}
                        >
                            {btnText}
                        </CustomButton>
                    }
                </Box>
            </Box>
            <Divider sx={{ my: 2 }} />
        </Box>
    )
}

export default HeaderTilteBar
